"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = exports.Value = exports.TimeRange = exports.SmallPopup = exports.SmallDot = exports.SessionName = exports.SessionDetailsModal = exports.SensorName = exports.RotatedIcon = exports.ProfileName = exports.NoData = exports.ModalMobileHeader = exports.ModalDesktopHeader = exports.MinMaxValueContainer = exports.InfoContainer = exports.HeaderWrapper = exports.ContentWrapper = exports.ClickableWrapper = exports.CancelButtonX = exports.ButtonsContainer = exports.Button = exports.BlueButton = exports.AverageValueContainer = exports.AverageValue = exports.AverageDot = void 0;
const react_router_dom_1 = require("react-router-dom");
const reactjs_popup_1 = __importDefault(require("reactjs-popup"));
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../../assets/styles/colors");
const media_1 = require("../../../../utils/media");
const ActionButton_style_1 = require("../../../atoms/ActionButton/ActionButton.style");
const Typography_1 = require("../../../atoms/Typography");
const SessionDetailsModal = (0, styled_components_1.default)(reactjs_popup_1.default) `
  width: 100%;
  height: 100%;

  &-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    pointer-events: none !important;
    z-index: 4 !important;
  }

  &-content {
    width: 100%;
    background-color: ${colors_1.white};
    padding: 0.5rem;
    border-radius: 10px 10px 0 0;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    max-height: 80vh;
    overflow-y: auto;
    margin: 0;
    display: flex;
    flex-direction: row-reverse;
    flex-wrap: wrap;

    @media ${media_1.media.smallDesktop} {
      padding-bottom: 1.25rem;
      flex-direction: row;
    }
  }
`;
exports.SessionDetailsModal = SessionDetailsModal;
const InfoContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  gap: 4rem;

  @media ${media_1.media.desktop} {
    width: 20%;
    flex-direction: column;
    justify-content: space-evenly;
    margin-bottom: 0;
    padding: 3rem 3rem 0 3rem;
    gap: 1.6rem;
  }
`;
exports.InfoContainer = InfoContainer;
const ModalMobileHeader = styled_components_1.default.div `
  display: flex;
  width: 100%;
  flex-direction: column;
`;
exports.ModalMobileHeader = ModalMobileHeader;
const ModalDesktopHeader = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;
exports.ModalDesktopHeader = ModalDesktopHeader;
const SessionName = (0, styled_components_1.default)(Typography_1.H2) `
  font-weight: 500;
  font-size: 1.8rem;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: none;

  @media ${media_1.media.smallDesktop} {
    font-size: 2.4rem;
  }
`;
exports.SessionName = SessionName;
const ProfileName = styled_components_1.default.span `
  font-size: 1.2rem;
  font-weight: 400;
`;
exports.ProfileName = ProfileName;
const SensorName = styled_components_1.default.span `
  font-size: 1.2rem;
  font-weight: 400;
  color: ${colors_1.gray300};
`;
exports.SensorName = SensorName;
const AverageValueContainer = styled_components_1.default.div `
  font-size: 1.2rem;
  display: flex;
  align-items: center;
`;
exports.AverageValueContainer = AverageValueContainer;
const AverageValue = styled_components_1.default.span `
  font-size: 1.6rem;
  margin-right: 0.5rem;
`;
exports.AverageValue = AverageValue;
const AverageDot = styled_components_1.default.div `
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: ${(props) => props.$color};
  display: inline-block;
  margin-right: 1rem;
`;
exports.AverageDot = AverageDot;
const SmallDot = styled_components_1.default.div `
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => props.$color};
  display: inline-block;
  margin-right: 0.5rem;
`;
exports.SmallDot = SmallDot;
const ButtonsContainer = styled_components_1.default.div `
  display: none;
  @media ${media_1.media.smallDesktop} {
    display: flex;
    justify-content: flex-start;
    gap: 0.5rem;
  }
`;
exports.ButtonsContainer = ButtonsContainer;
const MinMaxValueContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  gap: 2rem;
  justify-content: ${(props) => (props.$isMobile ? "flex-end" : "flex-start")};
`;
exports.MinMaxValueContainer = MinMaxValueContainer;
const Value = styled_components_1.default.span `
  font-size: 1.6rem;
  margin-left: 0.3rem;
`;
exports.Value = Value;
const TimeRange = styled_components_1.default.div `
  font-size: 1.2rem;
  gap: 0.8rem;
  margin-bottom: 0.6rem;
`;
exports.TimeRange = TimeRange;
const Button = (0, styled_components_1.default)(ActionButton_style_1.ActionButton) `
  color: ${colors_1.gray300};
  background-color: ${colors_1.gray100};
  box-shadow: none;
  padding: 1.6rem;
  border: none;

  /* fix for outlines appearing on component load */

  body:not(.user-is-tabbing) &:focus-visible {
    outline: none;
  }
`;
exports.Button = Button;
const BlueButton = (0, styled_components_1.default)(react_router_dom_1.Link) `
  background-color: ${colors_1.white};
  color: ${colors_1.acBlueDark};
  font-weight: 100;
  width: fit-content;
  font-weight: 400;
  text-transform: uppercase;
  font-size: 1.4rem;
  letter-spacing: 0.14px;
  height: 4.2rem;
  border-radius: 10px;
  padding: 1.2rem;
  align-items: center;
  gap: 1rem;
  justify-content: flex-end;
  display: flex;
  text-decoration: none;
  border: 2px solid ${colors_1.blue};
  margin-right: 0.5rem;

  /* fix for outlines appearing on component load */

  body:not(.user-is-tabbing) &:focus-visible {
    outline: none;
  }

  @media ${media_1.media.largeDesktop} {
    padding: 1.6rem;
    border-radius: 5px;
  }
`;
exports.BlueButton = BlueButton;
const CancelButtonX = styled_components_1.default.button `
  border: none;
  background-color: transparent;
  position: absolute;
  top: 0.5rem;
  right: 0.3rem;
  height: fit-content;
  align-self: flex-end;
  cursor: pointer;

  body:not(.user-is-tabbing) &:focus-visible {
    outline: none;
  }
  @media ${media_1.media.smallDesktop} {
    width: fit-content;
  }
`;
exports.CancelButtonX = CancelButtonX;
const SmallPopup = (0, styled_components_1.default)(reactjs_popup_1.default) `
  width: 100%;
  height: auto;

  &-overlay {
  }

  &-content {
    background-color: ${colors_1.white};
    opacity: 1;
    border-radius: 8px;
    position: relative;
    padding: 1rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 6;
    display: flex;
    width: 180px;
    height: 91px;
  }
`;
exports.SmallPopup = SmallPopup;
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media ${media_1.media.smallDesktop} {
    gap: 1.6rem;
  }
`;
exports.Wrapper = Wrapper;
const NoData = styled_components_1.default.span `
  font-size: 1.6rem;
`;
exports.NoData = NoData;
const HeaderWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 1rem;
  padding: 1rem 1rem 0 0;
`;
exports.HeaderWrapper = HeaderWrapper;
const ContentWrapper = styled_components_1.default.div `
  display: ${(props) => (props.$isVisible ? "flex" : "none")};
  gap: 1rem;
  width: 100%;
  padding: 0.5rem 1rem;
  justify-content: space-between;
  align-items: center;
`;
exports.ContentWrapper = ContentWrapper;
const ClickableWrapper = styled_components_1.default.div `
  display: flex;
  gap: 2rem;
  align-items: center;
`;
exports.ClickableWrapper = ClickableWrapper;
const RotatedIcon = styled_components_1.default.img `
  transform: ${({ $rotated }) => ($rotated ? "rotate(180deg)" : "none")};
  cursor: pointer;
`;
exports.RotatedIcon = RotatedIcon;
